import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useWindowSize} from "../../../../../../hook/useWindowSize";
import {useMySearchParams} from "../../../../../../hook/useMySearchParams";
import {general} from "../../../../../../store/action";
import {connect, useSelector} from "react-redux";
import EmptyBox from "../../../../general/emptyBox";
import {useGetPatientVaccines} from "../../../../../../hook/request/ehr/patientVaccine";
import PatientVaccineSummary_rowItem from "./dataList/patientVaccineSummary_rowItem";
import AddPatientVaccineModal from "../../vaccine/addPatientVaccineModal";
import {TDataList} from "../../../../../../types/general";
import {useFindAccessInAccessList} from "../../../../../../constants/constant/accessProcess";


const dataListTitles = [
  "نام حساسیت",
  "شدت",
  "واکنش ها",
  "تاریخ شروع",
  "تاریخ پایان",
]

type TFilterValues = {
  patient?: string;
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

type patientVaccineSummaryProps = {
  patientData?: any;
  openTab?: string;
  handleShowModal: any;
  visitEHRCheck?: boolean;
}

const PatientVaccineSummary = ({
 patientData,
 openTab,
 handleShowModal,
 visitEHRCheck = false,
}: patientVaccineSummaryProps) => {

  const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [width] = useWindowSize();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [vaccinesData, setVaccinesData] = useState<TDataList>({
    data: [],
    count: 0
  });
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    patient: patientData ? patientData : '0',
    pageNumber: "0",
    perPage: "3",
    search: "",
  });

  // services
  const getAllergiesRequest = useGetPatientVaccines(getQueryParams(filterValues), openTab === 'patientSummary' && filterValues?.patient !== '0');

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      patient: patientData,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "3",
      search: searchParams.get("search") || "",
    }
    setFilterValues(_filterValues)
  }, [searchParams, patientData]);

  useEffect(() => {
    getAllergiesRequest?.data?.data?.result &&
    setVaccinesData(getAllergiesRequest?.data?.data.result)
  }, [getAllergiesRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const _dataList = vaccinesData?.data && vaccinesData?.data?.length > 0 && vaccinesData?.data?.map((item: any, i: number) => {
    return(
      <div className={`py-3 ${(i + 1) !== vaccinesData?.data?.length ? 'border-bottom' : ''}`}>
        <PatientVaccineSummary_rowItem key={i} item={item}/>
      </div>
    )
  });

  return (
    <>
      <div className="rounded">
        <section className=" d-flex flex-column align-items-center flex-md-row border-bottom">
          <div className="form-group ms-md-auto fw-bold mx-3 my-2">
            واکسیناسیون
          </div>
          {((visitEHRCheck && isProvider) || findAccessInAccessList('EHR_VACCINATIONS_CREATE')) &&
            <a className='p-1 d-flex align-items-center btn btn-dark rounded rounded-3 mx-3 my-2'
              onClick={() => handleShowModal('addPatientVaccineModal', {
                patientId: patientData,
                patientData: patientData
              })}>
              <span className="m-1">افزودن واکسن</span>
            </a>
          }
        </section>
        <section className="mx-3 my-2">
          {
            vaccinesData?.data?.length === 0 ? <EmptyBox/> : _dataList
          }
        </section>
      </div>
      {openTab === 'patientSummary' && <AddPatientVaccineModal/>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PatientVaccineSummary);
